import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useTranslation } from 'next-i18next'

export interface DurationProps {
	duration: number
}

export const Duration = ({ duration }: DurationProps) => {
	const { t } = useTranslation()

	return (
		<>
			{duration === 30
				? t('common:halfHour')
				: dateTimeUtils
						.duration(duration, 'minutes')
						.format('H[h]mm')
						.replace('h00', 'h')}
		</>
	)
}
